import { createFileRoute } from '@tanstack/react-router'

import { LogsPage } from '#/modules/system/logs-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/logs')({
  component: LogsPage,
  validateSearch: validateListSearch,
})
